export const redirectToUrl = (url: string) => (window.location.href = url);
